import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/console/$orgId/risk/')({
    staticData: {
        ui: {
            title: 'Risk',
        },
    },
    beforeLoad: ({ params }) => {
        throw redirect({ to: '/console/$orgId/risk/ras', params, replace: true });
    },
});
